export const isClientEnvironment =
	typeof navigator !== 'undefined' && typeof sessionStorage !== 'undefined'

export const getUserAgent = isClientEnvironment ? navigator.userAgent : ''

export const isAndroidAgent = (isMobile: boolean) =>
	/Android/i.test(getUserAgent) && isMobile
